import { domainProxy } from '@/store'
import { proxy, subscribe, useSnapshot } from 'valtio'

const localStorageId = 'routemanager/v1/atoms/outOfStorageSpace'

type OutOfStorageAcknoledgmentKey = string

type OutOfStorageSpaceAcknowledgment = Record<
  OutOfStorageAcknoledgmentKey,
  { outOfStorageModalAcknowledged: boolean }
>

const localStorageValue = localStorage.getItem(localStorageId)

const defaultValue: OutOfStorageSpaceAcknowledgment = {}

const storedValue: OutOfStorageSpaceAcknowledgment = localStorageValue
  ? JSON.parse(localStorageValue)
  : defaultValue

export const outOfStorageSpaceAcknowledgmentAtom =
  proxy<OutOfStorageSpaceAcknowledgment>(storedValue)

export function setOutOfStorageSpaceAcknowledgement(
  outOfStorageAcknoledgmentKey: string,
  value: boolean,
) {
  if (!outOfStorageAcknoledgmentKey) return
  outOfStorageSpaceAcknowledgmentAtom[outOfStorageAcknoledgmentKey] = {
    outOfStorageModalAcknowledged: value,
  }
}

export function clearAllOutOfStorageSpaceAcknowledgements() {
  Object.keys(outOfStorageSpaceAcknowledgmentAtom).forEach(outOfStorageAcknoledgmentKey => {
    delete outOfStorageSpaceAcknowledgmentAtom[outOfStorageAcknoledgmentKey]
  })
}

function createOutOfStorageAcknoledgmentKey(territoryId: string, simulationId?: string): string {
  return simulationId ? `${territoryId}-${simulationId}` : `${territoryId}-operations`
}

subscribe(outOfStorageSpaceAcknowledgmentAtom, () => {
  localStorage.setItem(localStorageId, JSON.stringify(outOfStorageSpaceAcknowledgmentAtom))
})

export function subscribeOutOfStorageData() {
  return domainProxy.subscribeToNotifications(
    notification => {
      if (notification.notificationType === 'routePlanInfo') {
        const routePlanInfo = notification.payload
        const { territoryId, simulationId } = routePlanInfo
        if (territoryId) {
          const outOfStorageAcknoledgmentKey = createOutOfStorageAcknoledgmentKey(
            territoryId,
            simulationId,
          )
          const acknowledged =
            outOfStorageSpaceAcknowledgmentAtom[outOfStorageAcknoledgmentKey]
              ?.outOfStorageModalAcknowledged || false
          setOutOfStorageSpaceAcknowledgement(outOfStorageAcknoledgmentKey, acknowledged)
        }
      }
    },
    ['routePlanInfo'],
  )
}

export const useOutOfStorageSpaceAcknowledgement = (OutOfStorageAcknoledgmentKey: string) => {
  const snapshot = useSnapshot(outOfStorageSpaceAcknowledgmentAtom)
  return [
    snapshot[OutOfStorageAcknoledgmentKey]?.outOfStorageModalAcknowledged,
    (value: boolean) => setOutOfStorageSpaceAcknowledgement(OutOfStorageAcknoledgmentKey, value),
    () => clearAllOutOfStorageSpaceAcknowledgements(),
  ] as const
}
